// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4593) return "static/chunks/4593-ce80fbe420069936.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3859":"ef2e9e3f7680a37a","5154":"5208796bbf89bfa3"}[chunkId] + ".js";
};